module.exports = __webpack_public_path__ + "img/704_1.e0cd8c30.jpg";